import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Lookup tables de segmentacao de empresas:
 *  - tipos_papel_empresa (codigo, rotulo) — usado no filtro "Tipo"
 *  - tipos_negocio (codigo, rotulo) — usado no filtro "Setor"
 *
 * Retorna options ja em formato react-select ({ value, label }).
 */
export const useTiposEmpresa = () => {
  const [papeis, setPapeis] = useState([]);
  const [setores, setSetores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [papeisRes, setoresRes] = await Promise.all([
        supabase
          .from('tipos_papel_empresa')
          .select('codigo, rotulo, ordem')
          .eq('ativo', true)
          .order('ordem'),
        supabase
          .from('tipos_negocio')
          .select('codigo, rotulo, ordem')
          .eq('ativo', true)
          .order('ordem'),
      ]);
      if (cancelled) return;
      setPapeis((papeisRes.data || []).map(r => ({ value: r.codigo, label: r.rotulo })));
      setSetores((setoresRes.data || []).map(r => ({ value: r.codigo, label: r.rotulo })));
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { papeis, setores, loading };
};
